import { axis, bob, canara, federal, hdfc, icici, sbi, union, yesbank } from '../../../../../public/banks';

export const profileTabs = [
  { name: 'Referrals', path: '/profile/' },
  { name: 'Basic details', path: '/profile/basic-details' },
  { name: 'My batches', path: '/profile/purchased-batches' },
  { name: 'Others', path: '/profile/others' },
];

export const BankIconMap = {
  UTIB: axis,
  BARB: bob,
  HDFC: hdfc,
  CNRB: canara,
  FDRL: federal,
  ICIC: icici,
  SBIN: sbi,
  YESB: yesbank,
  UBIN: union,
};
